import { Component, Vue, Prop } from "vue-property-decorator";
import { CreateElement, VNode } from "vue/types/umd";
import {
  NormalContract,
  NormalScheme,
  SchemeProgress,
  SchemeType
} from "@foxone/api/src/models/defi";
import SchemeIntroduction from "defi/components/partial/SchemeIntroduction.vue";
import SchemeRaisingProcess from "defi/components/partial/SchemeRaisingProcess.vue";
import Tabs from "./Tabs.vue";
import ContractHold from "./ContractHold.vue";
import WithdrawForm from "./WithdrawForm.vue";
import DepositForm from "./DepositForm.vue";
import { VContainer } from "vuetify/lib";

@Component
class NormalContractJoin extends Vue {
  @Prop() scheme!: NormalScheme;

  @Prop() contracts!: NormalContract[];

  opt = 0;

  get types() {
    return [this.$t("common.deposit"), this.$t("common.withdraw")];
  }

  get contract() {
    return this.contracts[0] ?? {};
  }

  genWithdrawForm() {
    const h = this.$createElement;
    const { scheme, contract } = this;
    const { quantity = 0, remain_revenue = 0, id = "" } = contract;
    const { pay_asset, withdraw_audit_limit } = scheme;
    const remain = Number(quantity ?? 0) + Number(remain_revenue ?? 0);

    let withdrawRatio = 0;
    if ("withdraw_ratio" in scheme) {
      withdrawRatio = +scheme.withdraw_ratio;
    }

    return h(WithdrawForm, {
      props: {
        contractId: id,
        remain,
        withdrawRatio,
        assets: [pay_asset],
        withdrawAuditLimit: +withdraw_audit_limit
      }
    });
  }

  genDepositForm() {
    const h = this.$createElement;
    const { scheme } = this;
    const {
      id,
      total_supply,
      surplus,
      progress,
      min_subscribe,
      max_subscribe,
      pay_asset,
      pay_asset_id
    } = scheme;
    const showProcess = scheme.type !== SchemeType.CURRENT && +total_supply > 0;
    const disabled = progress !== SchemeProgress.OPENING;
    const isFull = progress === SchemeProgress.FULL;
    const limits = {
      [pay_asset_id]: { min: +min_subscribe, max: +max_subscribe }
    };

    return [
      showProcess &&
        h(SchemeRaisingProcess, {
          props: { total: +total_supply, surplus: +surplus }
        }),
      h(DepositForm, {
        props: {
          schemeId: id,
          limits,
          disabled,
          isFull,
          assets: [pay_asset]
        }
      })
    ];
  }

  genForm() {
    if (this.opt === 0) {
      return this.genDepositForm();
    } else {
      return this.genWithdrawForm();
    }
  }

  genHold() {
    const h = this.$createElement;
    const {
      pay_asset = { symbol: "" },
      quantity = 0,
      remain_revenue = 0,
      total_revenue = 0,
      last_revenue = 0
    } = this.contract;

    return h(ContractHold, {
      props: {
        quantity: +quantity,
        asset: pay_asset,
        remainRevenue: +remain_revenue,
        totalRevenue: +total_revenue,
        lastRevenue: +last_revenue
      }
    });
  }

  genInfoPanel() {
    const h = this.$createElement;

    return h("f-panel", { staticClass: "mt-3" }, [
      this.genHold(),
      h(Tabs, {
        props: { value: this.opt, groups: this.types },
        on: { "update:value": v => (this.opt = v) }
      }),
      this.genForm()
    ]);
  }

  render(h: CreateElement): VNode {
    return h(VContainer, [
      h(SchemeIntroduction, { props: { scheme: this.scheme } }),
      this.genInfoPanel()
    ]);
  }
}

export default NormalContractJoin;
